import PropTypes from 'prop-types';
import styled from 'styled-components';

import devices from '@/utilities/devices';

const SectionContainer = styled.section`
  position: relative;
  width: 100%;
  height: ${props => props.fixedHeight && 'calc(100vh - 4.9em)'};
  max-height: auto;
  padding: ${props => !props.fixedHeight && '8em 0'};
  background: ${props => props.bgImage && `url(${props.bgImage})`};
  background-color: ${props => {
		switch (props.bgColor) {
			case 'red':
				return props.theme.color.red;
			case 'beige':
				return props.theme.color.beige;
			case 'blue':
				return props.theme.color.blue;
			case 'prune':
				return props.theme.color.prune;
			case 'white':
				return props.theme.color.white;
			default:
				return props.bgColor;
		}
	}};
  background-size: cover;
  background-position: center;
  color: ${props => (props.bgColor === 'red' || props.bgColor === 'prune' || props.bgColor === 'blue') ? props.theme.color.white : props.bgImage ? props.theme.color.white : props.theme.color.black};
  z-index: 998;
  opacity: .2;
  animation: fadeIn .2s ease forwards;
  @keyframes fadeIn {
      100% { opacity: 1; }
  }
  @media screen and (${devices.mobile}) {
    height: auto;
    padding: 0;
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    height: auto;
    padding: 0;
  }
`;

const Filter = styled.div`
  display: block;
  content: '';
  background-color: #000;
  opacity: ${props => props.opacity ? props.opacity : '.35'};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 4.9em);
  z-index: -999;
  transition: .4s;
  @media screen and (${devices.mobile}) {
    height: 100%;
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    height: 100%;
  }
`;

const Section = ({ className, children, bgColor, scrollTo, bgImage, opacity, fixedHeight }) => {
	return (
		<SectionContainer className={className} ref={scrollTo} bgImage={bgImage} bgColor={bgColor} fixedHeight={fixedHeight}>
			{children}
			{bgImage && <Filter opacity={opacity} />}
		</SectionContainer>
	);
};

Section.propTypes = {
	className: PropTypes.string,
	children: PropTypes.any,
	bgColor: PropTypes.string,
	scrollTo: PropTypes.object,
	bgImage: PropTypes.string,
	opacity: PropTypes.string,
	fixedHeight: PropTypes.bool,
};

export default Section;
